export * from './GiftedChat';
//# sourceMappingURL=index.js.map